import React, { PropTypes } from 'react';
import R from 'ramda';
import { Avatar } from 'material-ui';
import AttachFile from 'material-ui/svg-icons/editor/attach-file';
import FlatButton from '../../../tc-ui/flat-button-with-loader';
import AddToContractIcon from 'material-ui/svg-icons/content/add';
import moment from 'moment';
import pluralize from 'pluralize';

const isNilOrEmpty = R.either(R.isNil, R.isEmpty);
const ProfileImage = ({ profileImageUrl, isExternal, name }) => {
  if (isExternal) {
    return (<Avatar size={30} backgroundColor="rgba(0, 0, 0, 0.1)">
      <span style={{ fontSize: '9px', color: 'rgba(0, 0, 0, 0.67)' }}>offline</span>
    </Avatar>);
  }
  if (profileImageUrl) return <Avatar size={30} src={profileImageUrl}/>;
  return (
    <Avatar size={30}>
      {R.head(name)}
    </Avatar>
  );
};
const MatchedRequests = ({ addFilesToRequestsInDialog, matchedRequests, files }, { router }) => {
  const matchedRequestsGroupedByDates = (() => {
    if ((matchedRequests && matchedRequests.length)) {
      return R.groupBy((request) => {
        return `${moment.utc(request.startDate).format('D MMM YYYY')} - ${moment.utc(request.endDate).format('D MMM YYYY')}`;
      }, matchedRequests);
    }
    return [];
  })();
  return (
    <div>
      We’ve found the following {pluralize('contract', matchedRequests.length)}.
      {
        R.keys(matchedRequestsGroupedByDates).map(yearString => {
          const requests = matchedRequestsGroupedByDates[yearString];
          return (
            <div style={{ marginTop: '8px' }} key={yearString}>
              <b>Contract Period: {yearString}</b>
              <div style={{ border: '2px solid #e0e0e0', width: '100%', marginTop: '4px' }}>
                {
                  requests.map((request, requestIndex) => (
                    <div key={request._id} style={{ padding: '8px', borderBottom: requestIndex < requests.length - 1 ? '1px solid #e0e0e0' : 'none' }}>
                      <div className="flex-tc-sb" style={{ marginBottom: '4px', flexWrap: 'wrap' }}>
                        <ProfileImage
                          profileImageUrl={request.to.avatar}
                          name={request.to.name || ''}
                        />
                        <div style={{ marginLeft: '4px', width: '50%' }}>
                          <small style={{ display: 'block' }}>{request.to.name} ({`${request.files ? request.files.length : 0} files`})</small>
                          <small>{request.toEmails.join(', ')}</small>
                        </div>
                        <div style={{ marginLeft: '4px', width: '260px' }} className="flex-tc-sb">
                          <FlatButton
                            style={{ border: `1px solid #49708A`, height: '30px', lineHeight: '30px', minWidth: '167px' }}
                            onTouchTap={() => addFilesToRequestsInDialog(request, R.map(R.compose(
                              R.assoc('source', 'emailScrape'),
                              R.omit(['logs'])
                            ), files))}
                          >
                            <div className="flex-tc-sb">
                              <AddToContractIcon color="#49708A" style={{ marginLeft: '0px' }}/>
                              <span style={{ textTransform: 'none', color: '#49708A', padding: '0 4px' }}>
                                Add to This Contract
                              </span>
                            </div>
                          </FlatButton>
                          <FlatButton
                            onTouchTap={() => router.push(`/contracting/contract/${request._id}/details`)}
                            style={{ border: '1px solid #49708A', height: '30px', lineHeight: '30px', marginLeft: '4px', minWidth: '60px' }}
                            label="Open"
                            labelStyle={{ textTransform: 'none', color: '#49708A', padding: '0 4px', verticalAlign: '', top: '-1px' }}
                          />
                        </div>
                      </div>
                      {
                        // !isNilOrEmpty(request.files) && request.files.map((file, fileIndex) => (
                        //   <div key={`${file._id}${requestIndex}${fileIndex}`}>
                        //     <AttachFile style={{ height: '14px', color: 'grey' }}/>
                        //     <small>{file.name}</small>
                        //   </div>
                        // ))
                      }
                    </div>))
                }
              </div>
            </div>
          );
        })
      }
    </div>
  );
};
MatchedRequests.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default MatchedRequests;



// WEBPACK FOOTER //
// ./src/app/components/messaging/singleConv/dialog/matchedRequests.jsx